// Libraries
import React from 'react';

// Enums
import { MatrixQuestionDataType } from 'engagementReport/enums/propTypes';

// Hooks
import useMatrixPieChartData from 'engagementReport/hooks/useMatrixPieChartData';

// Components
import MatrixPieChart from 'engagementReport/components/matrix/MatrixPieChart';

const MatrixPieCharts = ({ data }) => {
  const chartData = useMatrixPieChartData(data);

  return chartData.map(({ label, values }, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <MatrixPieChart label={label} values={values} weights={data.weights} key={index} />
  ));
};

MatrixPieCharts.propTypes = {
  data: MatrixQuestionDataType.isRequired,
};

export default MatrixPieCharts;
